import { render } from "./video.vue?vue&type=template&id=6211fb98"
import script from "./video.vue?vue&type=script&lang=js"
export * from "./video.vue?vue&type=script&lang=js"

import "./video.vue?vue&type=style&index=0&id=6211fb98&lang=scss"
const cssModules = {}
import style1 from "./video.vue?vue&type=style&index=1&id=6211fb98&lang=scss&module=true"
cssModules["$style"] = style1

import exportComponent from "/Users/lihui/Desktop/project/student_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__